import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import WorkroomForm from './components/workroomForm';
import { createWorkroom, navigate, clearValidationErrors } from 'actionCreators';
import { getRole, getWorkroomErrors } from '../../../../reducers';
import ui from 'redux-ui';
import { urls } from 'helpers/url';

class WorkroomNew extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = () => { this.props.navigate(urls.workrooms()); };
    this.setSuccessMessage = name => this.props.updateUI('successMessage', `The workroom ${name} was successfully created.`);
  }

  componentWillUnmount = () => this.props.clearValidationErrors('WORKROOM');

  handleSave = workroom => this.props.createWorkroom(workroom).then(() => {
    this.props.navigate(urls.workrooms());
    this.setSuccessMessage(workroom.name);
  });

  render = () => (<WorkroomForm
    role={this.props.role}
    errors={this.props.errors}
    onSave={this.handleSave}
    onCancel={this.handleCancel}
  />);
}

WorkroomNew.propTypes = {
  updateUI: PropTypes.func,
  errors: PropTypes.object,
  createWorkroom: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  clearValidationErrors: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  errors: getWorkroomErrors(state) || {},
  role: getRole(state),
});

export default ui()(connect(
  mapStateToProps, { createWorkroom, navigate, clearValidationErrors },
)(WorkroomNew));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/workrooms/workroomNew.jsx